import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { sweetAlert } from '../../../utils/swal';
import {  getShiftDays } from 'src/app/utils/utils.common';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DynamicFareServiceService } from '../dynamic-fare-service/dynamic-fare-service.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import * as moment from 'moment-timezone';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-dynamic-fare-add',
  templateUrl: './dynamic-fare-add.component.html',
  styleUrls: ['./dynamic-fare-add.component.css']
})
export class DynamicFareAddComponent implements OnInit, OnDestroy {
  submitted = false;
  singleZoneFormSubmitted = false;
  addonServicesFormSubmitted = false;
  companies;
  fareForm: FormGroup;
  zoneFareForm: FormGroup;
  vehcileTypeForm: FormGroup;

  user;
  fareId;
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  fundingSourceList = [];
  daysList = getShiftDays;
  timeZone: any

  constructor(
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private dynamicFareService: DynamicFareServiceService,
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
  ) { }

 async ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
        this.fareId = this.activatedRoute.snapshot.url[1].path;
      }

      this.fareForm = this.fb.group({
        cooperate: ['', Validators.required],
        company: ['',Validators.required],
        perMile: ['', Validators.required],
        perMin: ['', Validators.required],
        minimumFare: [''],
        cancelCharges: ['', Validators.required],
        additionalPassengerCharges: [''],
        noShowCharges: ['0', Validators.required],
        pickupSurcharge: this.fb.group({
          fare: [''],
          per: [''],
          after: ['']
        }),

        baseFare: this.fb.group({
          fare: ['', Validators.required],
          for: ['', Validators.required],
        }),

        waitTime: this.fb.group({
          fare: ['', Validators.required],
          per: ['', Validators.required],
          after: ['', Validators.required],
        }),

        zones: [[]],
        isPerMileZone: [false],
        los: ['', Validators.required],
        spaceType: ['', Validators.required],
        preStartTime: ["", Validators.required],
        startTime: ["", Validators.required],
        preEndTime: ["", Validators.required],
        endTime: ['', Validators.required],
        days: [[], Validators.required],

        code: [""],
        perMileCode: [""],
        preUnLoadTime: [""],
        dryRunCode: [""],
        baseFareCode: [""],
        waitTimeCode: [""],
        weekendNightCode: [""],
        responseNightCode: [""],
        status: [""],
        preStartDate: ["", Validators.required],
        startDate: ["", Validators.required],
        preEndDate: ["", Validators.required],
        endDate: ['', Validators.required],


      });

      this.zoneFareForm = this.fb.group({
        fare: ['', Validators.required],
        from: ['', Validators.required],
        to: ['', Validators.required]
      });

      this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
     this.getFundingSourceList(),
     this.getLevelOfService(),
     this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3]) => {

        if (res1) {
          this.fundingSourceList = res1;
        }
        if (res2) {
          this.levelOfServiceList = res2;
        }
        if (res3) {
          this.spaceTypeMainList = res3;
        }

        this.getUser();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getFundingSourceList() {

    return this.corporateService.getCorporateUsers('active');
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        this.user = user;
        this.timeZone = user.timeZone;

        this.fareForm.patchValue({
        company: this.user._id
        });

        if (this.fareId) {
          this.getDynamicFareById();
        }

      });
  }

  getDynamicFareById() {
    this.dynamicFareService
      .getDynamicFareById(this.fareId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fareForm.patchValue({
            ...data,
            preStartTime : moment(data.startTime, "HH:mm"),
            preStartDate : moment(data.startDate),
            preEndDate : moment(data.endDate),
            // preStartTime: data.startTime,
            preEndTime: moment(data.endTime, "HH:mm")

          });

          this.onSelectLOS(data.los);
        }
      });
  }

  addZone() {
    this.singleZoneFormSubmitted = true;
    if (this.zoneFareForm.invalid) {
      return;
    }
    this.fareForm.value.zones.push(this.zoneFareForm.value);
    this.zoneFareForm.reset();
    this.singleZoneFormSubmitted = false;
  }

  removeZone(index) {
    const z = this.fareForm.value.zones;
    z.splice(index, 1);
    this.fareForm.patchValue({
      zones: z
    });
  }

  toggleZonePerMile() {
    this.fareForm.patchValue({
      isPerMileZone: !this.fareForm.value.isPerMileZone
    });
  }

  get form() {
    return this.fareForm.controls;
  }

  get zoneForm() {
    return this.zoneFareForm.controls;
  }

  onSelectLOS(losId) {
    this.spaceTypeList = [];
    if (!losId) {
      this.fareForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.fareForm.value.spaceType);
    if (!spaceTypes.length) {
      this.fareForm.patchValue({
        spaceType: ''
      });
    }
  }

  setStartTimeChange(evt) {
    this.fareForm.patchValue({
      startTime : moment(evt).tz(this.timeZone, true).format("HH:mm"),
    });
  };
  setStartDateChange(evt) {
    this.fareForm.patchValue({
      startDate: moment(evt).tz(this.timeZone, true).toISOString(),
    });
  };
  setEndDateChange(evt) {
    this.fareForm.patchValue({
      endDate: moment(evt).tz(this.timeZone, true).toISOString(),
    });
  };

  setEndTimeChange(evt) {
    this.fareForm.patchValue({
      endTime : moment(evt).tz(this.timeZone, true).format("HH:mm"),
    });
  }

  onSubmit() {
    console.log("Form Value",this.fareForm.value);
    this.submitted = true;
    if (this.fareForm.invalid) {
      return;
    }

    this.dynamicFareService
      .saveDynamicFare(this.fareForm.value, this.fareId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.router.navigateByUrl('rates');
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  ngOnDestroy(): void {
  }
}
